import { setLogrocketUser } from 'src/helpers/appHelpers'
import { loadedUser, loginDone, logout } from '../actions'
import { Middleware } from '../store'

export const userMiddleware: Middleware = api => nextDispatch => action => {
  switch (action.type) {
    case logout.type:
      try {
        sessionStorage.removeItem('notifications')
      } catch {}
      break
    case loadedUser.type:
      const id = action.account.value?.id ?? null
      setLogrocketUser(action.account)
      if (id && window.Appcues) {
        window.Appcues.identify(id)
      }
      break
    case loginDone.type:
      try {
        sessionStorage.clear()
      } catch {}
      setLogrocketUser(action.result)
      break
  }

  return nextDispatch(action)
}
